// eslint-disable-next-line
import { produce } from 'immer';

const INITIAL_VALUES = {
  id: '',
  sign: false,
  type: null,
  title: 'Document',
  content: '',
  model: true,
  participant: 'Stagiaires',
  signatureID: [],
  fillOut: false,
  load: false,
};

export const RESET = 'RESET';
export const UPDATE_LOAD = 'UPDATE_LOAD';
export const LOAD_DOCUMENT = 'LOAD_DOCUMENT';
export const UPDATE_DOC_ID = 'UPDATE_DOC_ID';
export const UPDATE_DOC_TYPE = 'UPDATE_DOC_TYPE';
export const UPDATE_FORM_TITLE = 'UPDATE_FORM_TITLE';
export const UPDATE_DOC_CONTENT = 'UPDATE_DOC_CONTENT';
export const UPDATE_SIGNATURE_ID = 'UPDATE_SIGNATURE_ID';
export const UPDATE_DOC_PARTICIPANT = 'UPDATE_DOC_PARTICIPANT';
export const UPDATE_FILLOUT_ID = 'UPDATE_FILLOUT_ID';

const documentReducer = (state = INITIAL_VALUES, action) =>
  // eslint-disable-next-line
  produce(state, draft => {
    switch (action.type) {
      case RESET:
        // Utiliser Object.assign pour réinitialiser les valeurs initiales
        return Object.assign(draft, INITIAL_VALUES);
      case LOAD_DOCUMENT:
        // Utiliser Object.assign pour charger le document
        return Object.assign(draft, action.payload);
      case UPDATE_LOAD:
        draft.load = action.payload;
        break;
      case UPDATE_DOC_ID:
        draft.id = action.payload;
        break;
      case UPDATE_DOC_TYPE:
        draft.type = action.payload;
        break;
      case UPDATE_FORM_TITLE:
        draft.title = action.payload;
        break;
      case UPDATE_DOC_CONTENT:
        draft.content = action.payload;
        break;
      case UPDATE_DOC_PARTICIPANT:
        draft.participant = action.payload;
        break;
      case UPDATE_SIGNATURE_ID:
        draft.signatureID = action.payload;
        break;
      case UPDATE_FILLOUT_ID:
        draft.fillOut = action.payload;
        break;
      default:
        return draft;
    }
  });

export default documentReducer;
